import React, {useEffect} from 'react'

export function componentMount(mountCallback, unmountCallback = () => true) {
	useEffect(() => {
		const unmount = unmountCallback()

		mountCallback()

		return () => {
			if (typeof unmount === 'function') {
				unmount()
			}
		}
	}, [])
}